<template>
    <b-button variant="light" size="sm" :title="GetTitle()"
        @click="CopyToClipboard()">
        <b-icon-clipboard v-if="!isCopying"></b-icon-clipboard>
        <b-icon-check v-if="isCopying"></b-icon-check>
    </b-button>
</template>
<script>

export default {
    name: 'clipboardbutton',
    props: { value:String },
    data() {
        return {
            isCopying: false
        }
    },
    methods: {
        CopyToClipboard() {
            navigator.clipboard.writeText(this.value);
            this.isCopying = true;
            setTimeout(() => {
                this.isCopying=false;
            }, 1000);
        },
        GetTitle() {
            return this.isCopying ? 'Kopierat!' : `Kopiera '${this.value}' till urklipp.`;
        }
    }
}

</script>